// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","Entry":"Entry","panel":"panel","clearFix":"clearFix","textArea":"textArea","isCandleLit":"isCandleLit","hideCandle":"hideCandle","panelContent":"panelContent","action":"action","lowerPanel":"lowerPanel","guidelines":"guidelines","divider":"divider","emailSignUp":"emailSignUp","emailCheckBox":"emailCheckBox","arrow":"arrow","buttonGroup":"buttonGroup","submit":"submit","cancel":"cancel","errorMessage":"errorMessage","errorIcon":"errorIcon"};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Person/components/GuestBook/css/CondolenceEntry.styl
// module id = 1640
// module chunks = 0